import { Component, OnDestroy, OnInit } from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  Validators
} from '@angular/forms';
import { SiteModel, SiteStepperModel } from 'src/app/models/index';
import {
  CommonService,
  LoadService,
  SiteService,
  SiteStepperService
} from 'src/app/services/index';
import { SiteUtilityService } from 'src/app/services/site-utility.service';
import { SiteStepperEnum } from 'src/app/shared';
import { AlertService, Constants } from 'src/app/shared/index';
export interface Process {
  siteId: string;
  processId: string;
  loadId: string;
  processName: string;
  inputConstraint: string;
  outputConstraint: string;
  workflowType: string;
}

/**
 * Form modal for water accordion
 *
 * @export
 * @interface ProcessWater
 */
export interface ProcessWater {
  siteId: string;
  processId: string;
  loadId: string;
  processName: string;
  inputConstraint: string;
  outputConstraint: string;
  workflowType: string;
}

/**
 * Form modal for gas accordion
 *
 * @export
 * @interface ProcessGas
 */
export interface ProcessGas {
  siteId: string;
  processId: string;
  loadId: string;
  processName: string;
  inputConstraint: string;
  outputConstraint: string;
  workflowType: string;
}

/**
 * Form modal for air accordion
 *
 * @export
 * @interface ProcessAir
 */
export interface ProcessAir {
  siteId: string;
  processId: string;
  loadId: string;
  processName: string;
  inputConstraint: string;
  outputConstraint: string;
  workflowType: string;
}

@Component({
  selector: 'app-process-and-load-details',
  templateUrl: './process-and-load-details.component.html',
  styleUrls: ['./process-and-load-details.component.scss']
})
export class ProcessAndLoadDetailsComponent implements OnInit, OnDestroy {
  siteId: string;
  siteModel: SiteModel;
  formdata: UntypedFormGroup;
  processes: any;

  process: Process;
  processWorkflow = [
    { type: 'MainProcess' },
    { type: 'PreProcess' },
    { type: 'PostProcess' },
    { type: 'BufferProcess' }
  ];

  loadDataOfSites = [];
  processname = '';
  inputconstraints = '';
  outputconstraints = '';
  workflowType = '';
  loadname = '';
  createNewProcess: string;
  isDuplicateProcessName = false;
  energyUtility = true;

  // For Water accordion
  formdataWater: UntypedFormGroup;
  processesWater: any;
  processWater: ProcessWater;
  processWaterWorkflow = [
    { type: 'MainProcess' },
    { type: 'PreProcess' },
    { type: 'PostProcess' },
    { type: 'BufferProcess' }
  ];
  loadWaterDataOfSites = [];
  createNewWaterProcess: string;
  isDuplicateWaterProcessName = false;
  waterUtility = true;

  // For Gas accordion
  formdataGas: UntypedFormGroup;
  processesGas: any;
  processGas: ProcessGas;
  processGasWorkflow = [
    { type: 'MainProcess' },
    { type: 'PreProcess' },
    { type: 'PostProcess' },
    { type: 'BufferProcess' }
  ];
  loadGasDataOfSites = [];
  createNewGasProcess: string;
  isDuplicateGasProcessName = false;
  gasUtility = true;

  // For Air accordion
  formdataAir: UntypedFormGroup;
  processesAir: any;
  processAir: ProcessAir;
  processAirWorkflow = [
    { type: 'MainProcess' },
    { type: 'PreProcess' },
    { type: 'PostProcess' },
    { type: 'BufferProcess' }
  ];
  loadAirDataOfSites = [];
  createNewAirProcess: string;
  isDuplicateAirProcessName = false;
  airUtility = true;

  constructor(
    private fb: UntypedFormBuilder,
    private siteStepperService: SiteStepperService,
    private loadService: LoadService,
    private siteService: SiteService,
    private alertService: AlertService,
    private commonService: CommonService,
    private siteUtilityService: SiteUtilityService
  ) {
    //Initialisation call for process modal for all utilities
    this.initNewProcess();
    this.initNewProcessWater();
    this.initNewProcessGas();
    this.initNewProcessAir();
  }

  private initNewProcess() {
    this.process = {
      siteId: '',
      loadId: '',
      processId: '',
      processName: '',
      inputConstraint: '',
      outputConstraint: '',
      workflowType: ''
    };
    this.isDuplicateProcessName = false;
  }

  /**
   * Defining modal for water process
   *
   * @private
   * @memberof ProcessAndLoadDetailsComponent
   */
  private initNewProcessWater() {
    this.processWater = {
      siteId: '',
      loadId: '',
      processId: '',
      processName: '',
      inputConstraint: '',
      outputConstraint: '',
      workflowType: ''
    };
    this.isDuplicateWaterProcessName = false;
  }

  /**
   * Defining modal for gas process
   *
   * @private
   * @memberof ProcessAndLoadDetailsComponent
   */
  private initNewProcessGas() {
    this.processGas = {
      siteId: '',
      loadId: '',
      processId: '',
      processName: '',
      inputConstraint: '',
      outputConstraint: '',
      workflowType: ''
    };
    this.isDuplicateGasProcessName = false;
  }

  /**
   * Defining modal for air process
   *
   * @private
   * @memberof ProcessAndLoadDetailsComponent
   */
  private initNewProcessAir() {
    this.processAir = {
      siteId: '',
      loadId: '',
      processId: '',
      processName: '',
      inputConstraint: '',
      outputConstraint: '',
      workflowType: ''
    };
    this.isDuplicateAirProcessName = false;
  }

  ngOnInit() {
    const t = this;
    this.createNewProcess = '';
    this.createNewWaterProcess = '';
    this.createNewGasProcess = '';
    this.workflowType = '';
    this.siteModel = new SiteModel();
    t.formdata = t.fb.group({
      createNewProcessCtr: [],
      processCtr: [],
      processnameCtr: [
        '',
        [
          Validators.required,
          Validators.maxLength(50),
          Validators.pattern('[a-zA-Z0-9_& ./:,-]*'),
          this.startWhitespace
        ]
      ],
      inputconstraintsCtr: [
        '',
        [Validators.minLength(1), Validators.maxLength(6), this.startWhitespace]
      ],
      outputconstraintsCtr: [
        '',
        [Validators.minLength(1), Validators.maxLength(6), this.startWhitespace]
      ],
      workflowTypeCtr: [],
      loadRIdCtr: ['']
    });

    // Creating form group for water form accordion
    t.formdataWater = t.fb.group({
      createNewWaterProcessCtr: [],
      processWaterCtr: [],
      processWaternameCtr: [
        '',
        [
          Validators.required,
          Validators.maxLength(50),
          Validators.pattern('[a-zA-Z0-9_& ./:,-]*'),
          this.startWhitespace
        ]
      ],
      inputconstraintsWaterCtr: [
        '',
        [Validators.minLength(1), Validators.maxLength(6), this.startWhitespace]
      ],
      outputconstraintsWaterCtr: [
        '',
        [Validators.minLength(1), Validators.maxLength(6), this.startWhitespace]
      ],
      workflowTypeWaterCtr: [],
      loadRIdWaterCtr: ['']
    });

    // Creating form group for gas form accordion
    t.formdataGas = t.fb.group({
      createNewGasProcessCtr: [],
      processGasCtr: [],
      processGasnameCtr: [
        '',
        [
          Validators.required,
          Validators.maxLength(50),
          Validators.pattern('[a-zA-Z0-9_& ./:,-]*'),
          this.startWhitespace
        ]
      ],
      inputconstraintsGasCtr: [
        '',
        [Validators.minLength(1), Validators.maxLength(6), this.startWhitespace]
      ],
      outputconstraintsGasCtr: [
        '',
        [Validators.minLength(1), Validators.maxLength(6), this.startWhitespace]
      ],
      workflowTypeGasCtr: [],
      loadRIdGasCtr: ['']
    });

    // Creating form group for air form accordion
    t.formdataAir = t.fb.group({
      createNewAirProcessCtr: [],
      processAirCtr: [],
      processAirnameCtr: [
        '',
        [
          Validators.required,
          Validators.maxLength(50),
          Validators.pattern('[a-zA-Z0-9_& ./:,-]*'),
          this.startWhitespace
        ]
      ],
      inputconstraintsAirCtr: [
        '',
        [Validators.minLength(1), Validators.maxLength(6), this.startWhitespace]
      ],
      outputconstraintsAirCtr: [
        '',
        [Validators.minLength(1), Validators.maxLength(6), this.startWhitespace]
      ],
      workflowTypeAirCtr: [],
      loadRIdAirCtr: ['']
    });

    this.siteStepperService.getStepperSubject().subscribe((data) => {
      if (
        data.selectedIndex === SiteStepperEnum.ProcessAndLoadDetails &&
        !this.commonService.isNullOrUndefined(data.siteModel)
      ) {
        this.refreshData();
        this.siteId = data.siteModel.siteId;
        this.siteModel = data.siteModel;

        //Enabling Accordion based on configured utility in site creation Form
        if (this.siteModel.configuredKpiUtilities.includes('Energy')) {
          this.energyUtility = false;
          this.getProcessAndLoadsOfSite();
        }
        if (this.siteModel.configuredKpiUtilities.includes('Water')) {
          this.waterUtility = false;
          this.getWaterProcessAndLoadsOfSite();
        }
        if (this.siteModel.configuredKpiUtilities.includes('Gas')) {
          this.gasUtility = false;
          this.getGasProcessAndLoadsOfSite();
        }
        if (this.siteModel.configuredKpiUtilities.includes('Air')) {
          this.airUtility = false;
          this.getAirProcessAndLoadsOfSite();
        }
      }
    });
  }
  public startWhitespace(control: UntypedFormControl) {
    if (
      (control.value as string) &&
      (control.value as string).indexOf(' ') == 0
    ) {
      return { whitespace: true };
    }
    return null;
  }
  ngOnDestroy() {}

  refreshData() {
    this.loadDataOfSites = [];
    this.createNewProcess = '';
    this.workflowType = '';
    this.initNewProcess();
  }

  getProcessAndLoadsOfSite() {
    const t = this;
    this.initNewProcess();
    t.siteService
      .getProcessAndLoadsBySiteId(t.siteId, false)
      .subscribe((data) => {
        // if (data.length > 0) {
        t.processes = data;
        t.getAllLoads();
        // }
      });
  }

  getAllLoads() {
    this.loadService
      .getLoadVerticesOfSiteBasedOnUtility(this.siteId, 'Energy')
      .subscribe((data) => {
        if (data.length > 0) {
          this.loadDataOfSites = data;
        }
      });
  }

  /**
   * Function to get all process and loads for particular siteId water utility
   *
   * @memberof ProcessAndLoadDetailsComponent
   */
  getWaterProcessAndLoadsOfSite() {
    const t = this;
    this.initNewProcessWater();
    t.siteUtilityService
      .getUtilityProcessAndLoadsBySiteId(t.siteId, 'Water', false)
      .subscribe((data) => {
        t.processesWater = data;
        t.getAllWaterLoads();
      });
  }

  /**
   * Function to get all process and loads for particular siteId gas utility
   *
   * @memberof ProcessAndLoadDetailsComponent
   */
  getGasProcessAndLoadsOfSite() {
    const t = this;
    this.initNewProcessGas();
    t.siteUtilityService
      .getUtilityProcessAndLoadsBySiteId(t.siteId, 'Gas', false)
      .subscribe((data) => {
        t.processesGas = data;
        t.getAllGasLoads();
      });
  }

  /**
   * Function to get all process and loads for particular siteId air utility
   *
   * @memberof ProcessAndLoadDetailsComponent
   */
  getAirProcessAndLoadsOfSite() {
    const t = this;
    this.initNewProcessAir();
    t.siteUtilityService
      .getUtilityProcessAndLoadsBySiteId(t.siteId, 'Air', false)
      .subscribe((data) => {
        t.processesAir = data;
        t.getAllAirLoads();
      });
  }

  /**
   * Function to get all loads for particular siteId water utility
   *
   * @memberof ProcessAndLoadDetailsComponent
   */
  getAllWaterLoads() {
    this.loadService
      .getLoadVerticesOfSiteBasedOnUtility(this.siteId, 'Water')
      .subscribe((data) => {
        if (data) {
          this.loadWaterDataOfSites = data;
        }
      });
  }

  /**
   * Function to get all loads for particular siteId gas utility
   *
   * @memberof ProcessAndLoadDetailsComponent
   */
  getAllGasLoads() {
    this.loadService
      .getLoadVerticesOfSiteBasedOnUtility(this.siteId, 'Gas')
      .subscribe((data) => {
        if (data) {
          this.loadGasDataOfSites = data;
        }
      });
  }

  /**
   * Function to get all loads for particular siteId air utility
   *
   * @memberof ProcessAndLoadDetailsComponent
   */
  getAllAirLoads() {
    this.loadService
      .getLoadVerticesOfSiteBasedOnUtility(this.siteId, 'Air')
      .subscribe((data) => {
        if (data) {
          this.loadAirDataOfSites = data;
        }
      });
  }

  insertProcessMaster() {
    const t = this;
    const params = {
      siteId: t.siteId,
      processId: t.process.processId,
      loadId: t.process.loadId,
      processName: t.process.processName,
      inputConstraint: t.process.inputConstraint,
      outputConstraint: t.process.outputConstraint,
      workflowType: t.process.workflowType
    };
    t.siteService.saveProcess(params).subscribe((data) => {
      if (data.result === Constants.SUCCESS) {
        this.alertService.message = 'Save success';
        this.alertService.showSuccess(this.alertService.message);
        t.getProcessAndLoadsOfSite();
      } else {
        this.alertService.message = data.message;
        this.alertService.showError(this.alertService.message);
      }
    });
  }

  /**
   * Function call to add new process for water utility when button with buttonId 'addWaterProcessbtn' is clicked
   *
   * @memberof ProcessAndLoadDetailsComponent
   */
  insertWaterProcessMaster() {
    const t = this;
    const params = {
      siteId: t.siteId,
      processId: t.processWater.processId,
      loadId: t.processWater.loadId,
      processName: t.processWater.processName,
      inputConstraint: t.processWater.inputConstraint,
      outputConstraint: t.processWater.outputConstraint,
      workflowType: t.processWater.workflowType,
      kpiName: 'Water'
    };
    t.siteUtilityService.saveUtilityProcessForSite(params).subscribe((data) => {
      if (data.result === Constants.SUCCESS) {
        this.alertService.message = 'Save success';
        this.alertService.showSuccess();
        t.getWaterProcessAndLoadsOfSite();
      } else {
        this.alertService.message = data.message;
        this.alertService.showError();
      }
    });
  }

  /**
   * Function call to add new process for gas utility when button with buttonId 'addGasProcessbtn' is clicked
   *
   * @memberof ProcessAndLoadDetailsComponent
   */
  insertGasProcessMaster() {
    const t = this;
    const params = {
      siteId: t.siteId,
      processId: t.processGas.processId,
      loadId: t.processGas.loadId,
      processName: t.processGas.processName,
      inputConstraint: t.processGas.inputConstraint,
      outputConstraint: t.processGas.outputConstraint,
      workflowType: t.processGas.workflowType,
      kpiName: 'Gas'
    };
    t.siteUtilityService.saveUtilityProcessForSite(params).subscribe((data) => {
      if (data.result === Constants.SUCCESS) {
        this.alertService.message = 'Save success';
        this.alertService.showSuccess();
        t.getGasProcessAndLoadsOfSite();
      } else {
        this.alertService.message = data.message;
        this.alertService.showError();
      }
    });
  }

  /**
   * Function call to add new process for air utility when button with buttonId 'addGasProcessbtn' is clicked
   *
   * @memberof ProcessAndLoadDetailsComponent
   */
  insertAirProcessMaster() {
    const t = this;
    const params = {
      siteId: t.siteId,
      processId: t.processAir.processId,
      loadId: t.processAir.loadId,
      processName: t.processAir.processName,
      inputConstraint: t.processAir.inputConstraint,
      outputConstraint: t.processAir.outputConstraint,
      workflowType: t.processAir.workflowType,
      kpiName: 'Air'
    };
    t.siteUtilityService.saveUtilityProcessForSite(params).subscribe((data) => {
      if (data.result === Constants.SUCCESS) {
        this.alertService.message = 'Save success';
        this.alertService.showSuccess();
        t.getAirProcessAndLoadsOfSite();
      } else {
        this.alertService.message = data.message;
        this.alertService.showError();
      }
    });
  }

  public previousStep = (event: any) => {
    event.preventDefault();
    this.siteStepperService.setSendStepper(true);
    this.siteStepperService.sendStepperSubject(
      new SiteStepperModel(SiteStepperEnum.ShiftDetails, this.siteModel)
    );
  };

  nextStep = (event: any) => {
    event.preventDefault();
    this.siteStepperService.setSendStepper(true);
    this.siteStepperService.sendStepperSubject(
      new SiteStepperModel(SiteStepperEnum.GroupConfiguration, this.siteModel)
    );
  };

  onProcessNameFocusOut() {
    const processName = this.process.processName.toLowerCase();
    this.isDuplicateProcessName = false;
    if (processName && processName !== '') {
      if (this.processes && this.processes.length > 1) {
        for (let i = 0; i < this.processes.length; i++) {
          if (this.processes[i].name.toLowerCase() === processName) {
            this.isDuplicateProcessName = true;
            break;
          }
        }
      }
    }

    if (this.isDuplicateProcessName) {
      this.formdata.get('processnameCtr').setErrors({ duplicated: true });
    } else {
      const error = this.formdata.get('processnameCtr').getError('duplicated');
      if (error) {
        this.formdata.get('processnameCtr').setErrors(null);
      }
    }
  }

  onCreateNewProcessSelectionChanged() {
    this.process.processName = '';
    this.onProcessNameFocusOut();
  }

  /**
   * Function call to check for duplicate process name for water utility
   *
   * @memberof ProcessAndLoadDetailsComponent
   */
  onWaterProcessNameFocusOut() {
    const processWaterName = this.processWater.processName.toLowerCase();
    this.isDuplicateWaterProcessName = false;
    if (processWaterName && processWaterName !== '') {
      if (this.processesWater && this.processesWater.length > 1) {
        for (let i = 0; i < this.processesWater.length; i++) {
          if (this.processesWater[i].name.toLowerCase() === processWaterName) {
            this.isDuplicateWaterProcessName = true;
            break;
          }
        }
      }
    }

    if (this.isDuplicateWaterProcessName) {
      this.formdataWater
        .get('processWaternameCtr')
        .setErrors({ duplicated: true });
    } else {
      const error = this.formdataWater
        .get('processWaternameCtr')
        .getError('duplicated');
      if (error) {
        this.formdataWater.get('processWaternameCtr').setErrors(null);
      }
    }
  }

  /**
   * Function call to check for duplicate process name for gas utility
   *
   * @memberof ProcessAndLoadDetailsComponent
   */
  onGasProcessNameFocusOut() {
    const processGasName = this.processGas.processName.toLowerCase();
    this.isDuplicateGasProcessName = false;
    if (processGasName && processGasName !== '') {
      if (this.processesGas && this.processesGas.length > 1) {
        for (let i = 0; i < this.processesGas.length; i++) {
          if (this.processesGas[i].name.toLowerCase() === processGasName) {
            this.isDuplicateGasProcessName = true;
            break;
          }
        }
      }
    }

    if (this.isDuplicateGasProcessName) {
      this.formdataGas.get('processGasnameCtr').setErrors({ duplicated: true });
    } else {
      const error = this.formdataGas
        .get('processGasnameCtr')
        .getError('duplicated');
      if (error) {
        this.formdataGas.get('processGasnameCtr').setErrors(null);
      }
    }
  }

  /**
   * Function call to check for duplicate process name for air utility
   *
   * @memberof ProcessAndLoadDetailsComponent
   */
  onAirProcessNameFocusOut() {
    const processAirName = this.processAir.processName.toLowerCase();
    this.isDuplicateAirProcessName = false;
    if (processAirName && processAirName !== '') {
      if (this.processesAir && this.processesAir.length > 1) {
        for (let i = 0; i < this.processesAir.length; i++) {
          if (this.processesAir[i].name.toLowerCase() === processAirName) {
            this.isDuplicateAirProcessName = true;
            break;
          }
        }
      }
    }

    if (this.isDuplicateAirProcessName) {
      this.formdataAir.get('processAirnameCtr').setErrors({ duplicated: true });
    } else {
      const error = this.formdataAir
        .get('processAirnameCtr')
        .getError('duplicated');
      if (error) {
        this.formdataAir.get('processAirnameCtr').setErrors(null);
      }
    }
  }

  /**
   * Function call on creation of new process for water utility
   *
   * @memberof ProcessAndLoadDetailsComponent
   */
  onCreateNewWaterProcessSelectionChanged() {
    this.processWater.processName = '';
    this.onWaterProcessNameFocusOut();
  }

  /**
   * Function call on creation of new process for gas utility
   *
   * @memberof ProcessAndLoadDetailsComponent
   */
  onCreateNewGasProcessSelectionChanged() {
    this.processGas.processName = '';
    this.onGasProcessNameFocusOut();
  }

  /**
   * Function call on creation of new process for air utility
   *
   * @memberof ProcessAndLoadDetailsComponent
   */
  onCreateNewAirProcessSelectionChanged() {
    this.processAir.processName = '';
    this.onAirProcessNameFocusOut();
  }

  isFormValid() {
    if (this.createNewProcess === undefined || this.createNewProcess === '') {
      return false;
    }

    if (this.createNewProcess === 'true') {
      if (
        this.commonService.isNullOrUndefined(this.process.processName) ||
        this.process.processName === ''
      ) {
        return false;
      }
      if (
        this.commonService.isNullOrUndefined(this.process.workflowType) ||
        this.process.workflowType === ''
      ) {
        return false;
      }
      if (
        this.commonService.isNullOrUndefined(this.process.loadId) ||
        this.process.loadId === ''
      ) {
        return false;
      }
      if (this.isDuplicateProcessName) {
        return false;
      }
    } else {
      if (
        this.commonService.isNullOrUndefined(this.process.processId) ||
        this.process.processId === ''
      ) {
        return false;
      }
      if (
        this.commonService.isNullOrUndefined(this.process.loadId) ||
        this.process.loadId === ''
      ) {
        return false;
      }
    }

    return true;
  }

  /**
   * Function call to check water utility form valid
   *
   * @return {*}
   * @memberof ProcessAndLoadDetailsComponent
   */
  isWaterFormValid() {
    if (
      this.createNewWaterProcess === undefined ||
      this.createNewWaterProcess === ''
    ) {
      return false;
    }

    if (this.createNewWaterProcess === 'true') {
      if (
        this.processWater.processName === null ||
        this.processWater.processName === undefined ||
        this.processWater.processName === ''
      ) {
        return false;
      }
      if (
        this.processWater.workflowType === null ||
        this.processWater.workflowType === undefined ||
        this.processWater.workflowType === ''
      ) {
        return false;
      }
      if (
        this.processWater.loadId === null ||
        this.processWater.loadId === undefined ||
        this.processWater.loadId === ''
      ) {
        return false;
      }
      if (this.isDuplicateWaterProcessName) {
        return false;
      }
    } else {
      if (
        this.processWater.processId === null ||
        this.processWater.processId === undefined ||
        this.processWater.processId === ''
      ) {
        return false;
      }
      if (
        this.processWater.loadId === null ||
        this.processWater.loadId === undefined ||
        this.processWater.loadId === ''
      ) {
        return false;
      }
    }

    return true;
  }

  /**
   * Function call to check gas utility form valid
   *
   * @return {*}
   * @memberof ProcessAndLoadDetailsComponent
   */
  isGasFormValid() {
    if (
      this.createNewGasProcess === undefined ||
      this.createNewGasProcess === ''
    ) {
      return false;
    }

    if (this.createNewGasProcess === 'true') {
      if (
        this.processGas.processName === null ||
        this.processGas.processName === undefined ||
        this.processGas.processName === ''
      ) {
        return false;
      }
      if (
        this.processGas.workflowType === null ||
        this.processGas.workflowType === undefined ||
        this.processGas.workflowType === ''
      ) {
        return false;
      }
      if (
        this.processGas.loadId === null ||
        this.processGas.loadId === undefined ||
        this.processGas.loadId === ''
      ) {
        return false;
      }
      if (this.isDuplicateGasProcessName) {
        return false;
      }
    } else {
      if (
        this.processGas.processId === null ||
        this.processGas.processId === undefined ||
        this.processGas.processId === ''
      ) {
        return false;
      }
      if (
        this.processGas.loadId === null ||
        this.processGas.loadId === undefined ||
        this.processGas.loadId === ''
      ) {
        return false;
      }
    }

    return true;
  }

  /**
   * Function call to check air utility form valid
   *
   * @return {*}
   * @memberof ProcessAndLoadDetailsComponent
   */
  isAirFormValid() {
    if (
      this.createNewAirProcess === undefined ||
      this.createNewAirProcess === ''
    ) {
      return false;
    }

    if (this.createNewAirProcess === 'true') {
      if (
        this.processAir.processName === null ||
        this.processAir.processName === undefined ||
        this.processAir.processName === ''
      ) {
        return false;
      }
      if (
        this.processAir.workflowType === null ||
        this.processAir.workflowType === undefined ||
        this.processAir.workflowType === ''
      ) {
        return false;
      }
      if (
        this.processAir.loadId === null ||
        this.processAir.loadId === undefined ||
        this.processAir.loadId === ''
      ) {
        return false;
      }
      if (this.isDuplicateAirProcessName) {
        return false;
      }
    } else {
      if (
        this.processAir.processId === null ||
        this.processAir.processId === undefined ||
        this.processAir.processId === ''
      ) {
        return false;
      }
      if (
        this.processAir.loadId === null ||
        this.processAir.loadId === undefined ||
        this.processAir.loadId === ''
      ) {
        return false;
      }
    }

    return true;
  }
}
